import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable({ providedIn: 'root' })
export class WorkflowTemplatesAnalytics extends AnalyticsBase {
  public readonly namespace = 'WorkflowTemplates';
  public readonly requireViewContext = true;

  public trackTemplateCreation(
    relatedFeature: string,
    kind: string = '',
    attachment: boolean = false,
  ) {
    this.track('TemplateCreated', {
      relatedFeature,
      kind,
      attachment,
    });
  }

  public trackTemplateInsertion(
    relatedFeature: string,
    kind: string = '',
    formContext: string = '',
  ) {
    this.track('TemplateInserted', {
      relatedFeature,
      kind,
      formContext,
    });
  }

  public trackTemplateUsageCheck(relatedFeature: string) {
    this.track('TemplateUsageCheck', {
      relatedFeature,
    });
  }
}
